import React from 'react';

import { useEmployersTableListQuery } from 'src/api';
import { ModalId } from 'src/constants/modals';
import { useFilterStorage } from 'src/hooks/common';
import { useEmployersUnderPEOPayrollProviderQueryVariables } from 'src/hooks/employer';
import { useCurrentPeoPayrollProviderStaff } from 'src/hooks/peoPayrollProviderStaff';
import { InviteEmployersByPeoPpModal } from 'src/modals/employer';

import { EmployersInnerTablePEOPayrollProviderStaff } from './EmployersInnerTablePEOPayrollProviderStaff';

export const EmployersTablePEOPayrollProviderStaff: React.FC = () => {
  const { peoPayrollProviderId } = useCurrentPeoPayrollProviderStaff();
  const queryVariables = useEmployersUnderPEOPayrollProviderQueryVariables(peoPayrollProviderId);
  const { pagination } = useFilterStorage();

  const {
    data: employers,
    loading,
    refetch,
  } = useEmployersTableListQuery({
    variables: queryVariables,
    skip: !peoPayrollProviderId,
    notifyOnNetworkStatusChange: true,
  });

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  const employersList = React.useMemo(() => {
    return employers?.employerList ?? [];
  }, [employers?.employerList]);

  const employersCount = React.useMemo(() => {
    return employers?.employerCount || 0;
  }, [employers?.employerCount]);

  return (
    <React.Fragment>
      <EmployersInnerTablePEOPayrollProviderStaff
        employersList={employersList}
        employersCount={employersCount}
        loading={loading}
        inviteModalId={ModalId.InviteEmployersByPeoPp}
        pagination={pagination}
        onRefresh={refetchData}
      />
      <InviteEmployersByPeoPpModal />
    </React.Fragment>
  );
};
